var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0128 0.362636C16.7869 0.560437 17.3992 1.14286 17.6072 1.87912C17.9884 3.21978 18 6 18 6C18 6 18 8.79121 17.6187 10.1209C17.4108 10.8571 16.7985 11.4396 16.0244 11.6374C14.6264 12 9 12 9 12C9 12 3.37356 12 1.97561 11.6374C1.20154 11.4396 0.589218 10.8571 0.381258 10.1209C0 8.78022 0 6 0 6C0 6 0 3.21978 0.369704 1.89011C0.577664 1.15385 1.18999 0.57143 1.96406 0.373629C3.362 0.0109863 8.98845 0 8.98845 0C8.98845 0 14.6149 0 16.0128 0.362636ZM11.8652 6L7.19769 8.57143V3.42857L11.8652 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.c5d037bd0f305fcfd8b95a2a22a3fd4d.svg";
export { ForwardRef as ReactComponent };